"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatbotHelper = exports.SinistroType = void 0;
const nodejs_library_1 = require("@tpd-web-common-libs/nodejs-library");
const providers_1 = require("../../providers");
var SinistroType;
(function (SinistroType) {
    SinistroType["property"] = "property";
    SinistroType["dueVeicoli"] = "dueVeicoli";
    SinistroType["otherAuto"] = "otherAuto";
})(SinistroType = exports.SinistroType || (exports.SinistroType = {}));
class ChatbotHelper {
    constructor() {
        this.chatbotVisible = false;
        this._localStorageLayer = new providers_1.LocalStorageLayer();
        this.initData();
    }
    initData() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this._localStorageLayer.getData1().then((response) => {
                this.data1 = response;
            });
        });
    }
    extractFromData1(key) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        let value = '';
        switch (key) {
            case 'cellulare':
                value = (_d = (_c = (_b = (_a = this.data1) === null || _a === void 0 ? void 0 : _a.registry) === null || _b === void 0 ? void 0 : _b.contactInformations) === null || _c === void 0 ? void 0 : _c.filter((contact) => contact.type === '3').map((contact) => contact.value)[0]) !== null && _d !== void 0 ? _d : '';
                break;
            case 'email':
                value = (_h = (_g = (_f = (_e = this.data1) === null || _e === void 0 ? void 0 : _e.registry) === null || _f === void 0 ? void 0 : _f.contactInformations) === null || _g === void 0 ? void 0 : _g.filter((contact) => contact.type === '4').map((contact) => contact.value)[0]) !== null && _h !== void 0 ? _h : '';
                break;
            case 'firstname':
                value = (_j = this.data1.registry.name) !== null && _j !== void 0 ? _j : '';
                break;
            case 'lastname':
                value = (_k = this.data1.registry.surname) !== null && _k !== void 0 ? _k : '';
                break;
            case 'codiceFiscale':
                value = (_l = this.data1.registry.taxCodeVAT) !== null && _l !== void 0 ? _l : '';
                break;
        }
        return value;
    }
    showOrHideChatbot(show, sinistroType) {
        if (show) {
            document.body.style.overflow = 'hidden';
            this.triggerChatConversation(sinistroType);
            const chatbot = document.getElementById('chatbot-container');
            if (chatbot != null) {
                chatbot.classList.remove('hidden');
                chatbot.classList.add('visible');
            }
            this.chatbotVisible = true;
        }
        else {
            document.body.style.overflow = 'auto';
            console.error('remove visible');
            const chatbot = document.getElementById('chatbot-container');
            if (chatbot != null) {
                console.error('chatbot not null');
                chatbot.classList.add('hidden');
                chatbot.classList.remove('visible');
            }
            this.chatbotVisible = false;
        }
    }
    getIntentWhenOpeningChat() {
        return 'generic';
    }
    triggerChatConversation(sinistroType) {
        console.error('trigger chat conversation');
        window.postMessage({
            type: 'init',
            data: {
                intent: this.getIntentWhenOpeningChat(),
                intentParameters: {
                    chatbotType: 'sinistri',
                    complaintProperty: this.getComplaintProperty(sinistroType),
                    chatbotSource: 'web-desktop',
                    email: this.extractFromData1('email'),
                    firstname: this.extractFromData1('firstname'),
                    lastname: this.extractFromData1('lastname'),
                    codiceFiscale: this.extractFromData1('codiceFiscale'),
                    cellulare: this.extractFromData1('cellulare'),
                    complaintAuto: this.getComplaintAuto(sinistroType),
                    numberAuto: this.getNumberAuto(sinistroType),
                    data: this.data1
                }
            }
        }, this.getTargetOrigin());
    }
    getComplaintProperty(sinistroType) {
        switch (sinistroType) {
            case "property":
                return true;
            default:
                return false;
        }
    }
    getComplaintAuto(sinistroType) {
        switch (sinistroType) {
            case "dueVeicoli":
            case "otherAuto":
                return true;
            default:
                return false;
        }
    }
    getNumberAuto(sinistroType) {
        switch (sinistroType) {
            case "dueVeicoli":
                return 2;
            case "otherAuto":
                return 3;
            default:
                return null;
        }
    }
    trackChatbotCloseAction() {
        console.error('hello');
    }
    getTargetOrigin() {
        const currentUrl = window.location.href;
        if (currentUrl.includes(`inte.${nodejs_library_1.Helpers.BrandNameHelper.urlName()}.it`)) {
            return `https://inte.${nodejs_library_1.Helpers.BrandNameHelper.urlName()}.it`;
        }
        else if (currentUrl.includes(`coll.${nodejs_library_1.Helpers.BrandNameHelper.urlName()}.it`)) {
            return `https://coll.${nodejs_library_1.Helpers.BrandNameHelper.urlName()}.it`;
        }
        else if (currentUrl.includes(`qa.${nodejs_library_1.Helpers.BrandNameHelper.urlName()}.it`)) {
            return `https://qa.${nodejs_library_1.Helpers.BrandNameHelper.urlName()}.it`;
        }
        else if (currentUrl.includes(`${nodejs_library_1.Helpers.BrandNameHelper.urlName()}.it`)) {
            return `https://www.${nodejs_library_1.Helpers.BrandNameHelper.urlName()}.it`;
        }
        else {
            return '';
        }
    }
}
exports.ChatbotHelper = ChatbotHelper;
